
    import Vue from 'vue';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
/**
 * 通用的ELEMENT-UI组件配置内容
 */

function getQuarter(month) {
  if (month <= 2) {
    return 0
  } else if (month <= 5) {
    return 3
  } else if (month <= 8) {
    return 6
  } else {
    return 9
  }
}

// 选则日期范围组件
const dateRangePick = {
  // dateRangePick的快捷选中时间范围配置
  pickerOptions: {
    disabledDate: time => time.getTime() > Date.now(),
    shortcuts: [
      {
        text: $t('204e47'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setMilliseconds(0)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('87ecbe'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setDate(end.getDate() - 1)
          start.setMilliseconds(0)
          end.setDate(end.getDate() - 1)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('c997ff'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setDate(end.getDate() - 6)
          start.setMilliseconds(0)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('fedb5b'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setDate(end.getDate() - 13)
          start.setMilliseconds(0)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('3922cf'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setDate(end.getDate() - 29)
          start.setMilliseconds(0)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('a2c604'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setDate(end.getDate() - 179)
          start.setMilliseconds(0)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('211eb4'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          const day = start.getDay() // 0 (Sunday) to 6 (Saturday)
          // 调整为周一开始（如果周日则减6天，其他情况减(day-1)天）
          start.setDate(start.getDate() - (day === 0 ? 6 : day - 1))
          start.setMilliseconds(0)
          end.setMilliseconds(999) // 直接使用当天作为结束日期
          return [start, end]
        },
      },
      {
        text: $t('3661ff'),
        onClick(emit) {
          const start = new Date()
          const end = new Date()
          const day = start.getDay() // 0 (Sunday) to 6 (Saturday)
          // 计算上周一（当前日期 - (day-1) -7天）
          start.setDate(start.getDate() - (day === 0 ? 6 : day - 1) - 7)
          start.setMilliseconds(0)
          // 计算上周日（上周一 +6天）
          end.setDate(end.getDate() - (day === 0 ? 7 : day))
          end.setMilliseconds(999)
          console.log($t('3661ff'), start, end)
          return [start, end]
        },
      },
      {
        text: $t('08ad99'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setDate(1)
          start.setMilliseconds(0)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('464bc3'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setMonth(end.getMonth() - 1) // Set to the first day of the last month
          start.setDate(1)
          start.setMilliseconds(0)
          end.setDate(0) // Set to the last day of the last month
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('be48b6'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          let month = start.getMonth()
          let quarterStartMonth = getQuarter(month)
          start.setMonth(quarterStartMonth)
          start.setDate(1)
          start.setMilliseconds(0)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      // {
      //   text: '上季度',
      //   onClick(emit) {
      //     const end = new Date()
      //     const start = new Date()
      //     const currentMonth = end.getMonth()
      //     const currentYear = end.getFullYear()

      //     // 计算上季度年份和起始月份
      //     let lastQuarterYear = currentYear
      //     let lastQuarterStart = getQuarter(currentMonth) - 3
      //     if (lastQuarterStart < 0) {
      //       lastQuarterStart = 9 // 上一年第四季度
      //       lastQuarterYear = currentYear - 1
      //     }

      //     // 设置季度开始时间（年月日）
      //     start.setFullYear(lastQuarterYear, lastQuarterStart, 1)
      //     start.setMilliseconds(0)

      //     // 计算季度结束时间（最后一天）
      //     end.setFullYear(lastQuarterYear, lastQuarterStart + 3, 0) // 下个季度的第0天
      //     end.setMilliseconds(999)

      //     return [start, end]
      //   },
      // },
      {
        text: $t('efa51a'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setMonth(0)
          start.setDate(1)
          start.setMilliseconds(0)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
      {
        text: $t('46e0a4'),
        onClick(emit) {
          const end = new Date()
          const start = new Date()
          start.setFullYear(end.getFullYear() - 1) // Set to the first day of last year
          start.setMonth(0)
          start.setDate(1)
          start.setMilliseconds(0)
          end.setFullYear(end.getFullYear() - 1) // Set to the last day of last year
          end.setMonth(11)
          end.setDate(31)
          end.setMilliseconds(999)
          // picker.$emit("pick", [start, end])
          return [start, end]
        },
      },
    ],
  },
}

export default { dateRangePick }
